interface HoldBatchResult {
  count: number;
  errors: string[];
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

// The generated batch client's Hold decoder drops the actual count/errors response.
// Read the raw generated-client response and validate the server's batch contract.
export const readHoldBatchResult = (
  value: unknown,
  countField: 'confirmed_count' | 'challenged_count',
  requestedIds: string[],
): HoldBatchResult => {
  if (!isRecord(value)) {
    throw new Error('Invalid hold-operation response. Refresh to check which dates changed.');
  }
  const count = value[countField];
  if (typeof count !== 'number' || !Number.isInteger(count) || count < 0 || count > requestedIds.length) {
    throw new Error('Invalid hold-operation count. Refresh to check which dates changed.');
  }
  const errors: unknown[] = [];
  if (value.errors !== null) {
    if (!Array.isArray(value.errors)) {
      throw new Error('Invalid hold-operation errors. Refresh to check which dates changed.');
    }
    errors.push(...value.errors);
  }
  if (count + errors.length > requestedIds.length) {
    throw new Error('Invalid hold-operation errors. Refresh to check which dates changed.');
  }
  const failedIds = new Set<string>();
  const messages: string[] = [];
  for (const error of errors) {
    if (!isRecord(error) || typeof error.hold_id !== 'string' || typeof error.error !== 'string'
      || !requestedIds.includes(error.hold_id) || failedIds.has(error.hold_id)) {
      throw new Error('Invalid per-date result. Refresh to check which dates changed.');
    }
    failedIds.add(error.hold_id);
    messages.push(`${error.hold_id}: ${error.error}`);
  }
  if (count + failedIds.size !== requestedIds.length) {
    messages.push('Some selected dates were not processed. Refresh and review the selection.');
  }
  return { count, errors: messages };
};
